
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {dictApi, userApi} from "@/api/organization";
    const {regionData,Con} =require("@/js/region/region");
    const {checkTypeList, checkResultList} = require("@/js/checkType");

    @Component
    export default class InstrumentSubmit extends Vue {
        title = "器具查询条件";
        showForm = false;
        regionData = regionData;
        form = {
            name: "",          //器具名称
            instrNo: "",       //唯一标识
            categoryName: "",  //对象特征
            className: "",     //测量对象
            majorName: "",   //专业大类
            addrName: "",      //器具类别
            typeName: "",      //器具类型
            manufactoryName: "",      //制造单位
            modelSpecific: "",      //规格型号
            licence: "",      //型批证号
            serialNumber: "",      //出厂编号
            internalNumber: "",      //内部编号
            useUnit: "",      //使用单位
            useAddrCode: "",      //单位区域
            useOrgAddrCode: "", //使用区域
            purposeName: "",      //工作器具用途
            productionStartTime: "",      //生产开始日期
            productionEndTime: "",      //生产结束日期
            states: "",      //器具状态
            useDeptName: "",      //使用部门
            custodianName: "",      //责任人员
            measureRange: "",      //测量范围
            accuracyLevel: "",      //准确度等级
            mainMaterial: "",      //主体材料
            appearance: "",      //外观
            examineNum: "",      //检定
            recordNum: "",      //备案
            purchaseStartDate: "",      //购置开始日期
            purchaseEndDate: "",      //购置结束日期
            checkType: "",  //备案状态
            checkResult: "", // 检定状态
            orderApplyNumber: "",//申请单编号
            catalogue: [], //器具目录

        } as any
        addrCodeList = [];  //器具类别列表
        statesList = [];  //器具状态列表
        purposeCodeList = [];  //器具用途列表
        instrCatalogueTree = []; //器具目录数据列表
        typeCodeList = [];
        checkTypeList = checkTypeList;
        checkResultList = checkResultList;
        /**
         * 控制展示参数
         * check 备案状态下拉展示控制
         */
        @Prop() private check!: any;

        /**
         * 控制展示参数
         * 检定状态下拉展示
         */
        @Prop() private modeType!: any;

        @Prop() private  defaultCheckResult !: any;

        //本区域工作计量器具 THIS_AREA_WORK_INSTR
        mode = "";

        created() {
            this.getDict(3);
            this.getDict(7);
            this.getDict(2);
            this.getDict(1);
            this.getCatalogueTree();

          const typeCode = this.$route.query.typeCode;
          if(typeCode){
            this.mode = "THIS_AREA_WORK_INSTR";
            this.form.typeName = typeCode;
          }
        }
        getCatalogueTree(){
            dictApi.listInstrumentCatalogueTree().then((r) => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTreeV2(rData);
                    this.instrCatalogueTree = rData;
                }
            });
        }
        porjectTreeV2(projectList: any){
            projectList.forEach((project: any) => {
                if(project.children.length == 0){
                    project.children = null;
                }else{
                    this.porjectTreeV2(project.children);
                }
            })
        }
        getDict(category: number, code: string | string = ""){
            return dictApi.list({
                category: category,
                code: code
            }).then(r=>{
                if(r.data.result === 0){
                    const rData = r.data.data;
                    if(category == 3){
                        this.addrCodeList = rData;
                    }
                    else if(category == 2) {
                        this.purposeCodeList = rData;
                    }
                    else if(category == 7){
                        this.statesList = rData;
                    }
                    else if(category == 1){
                        this.typeCodeList = rData;
                    }
                }
            })
        }
        reset(){
            for(const f in this.form){
                this.form[f] = "";
            }
            this.refresh();
        }
        hideForm(){
            this.showForm = false;
        }
        refresh(){
            const form = JSON.parse( JSON.stringify(this.form))
            if(form.catalogue.length > 0){
                form.catalogueOne = form.catalogue[0];
            }
            if(form.catalogue.length > 1){
                form.catalogueTwo = form.catalogue[1];
            }
            form.catalogue = null;
            this.$emit("subBtn", form);
        }
        handleUpdateChange(value: any) {
            this.form.useAddrCode = value.join(",").replace(/\s+/g, "");
        }
    }
